<h1 mat-dialog-title style="margin-bottom: 0px">
  {{ data.name }} se verklaring
</h1>
<h3>
  Hiermee verklaar ek, {{ data.name }} {{ data.surname }}, op
  {{ data.serviceTime | date: "d MMMM" }} die volgende:
</h3>
<div mat-dialog-content>
  <div class="wrapper">
    <p>
      Verlies aan smaak/reuk, naarheid/braking/diarree, moegheid, koors, nies,
      hoes, seer keel, kortasem, aanraking met COVID-19?
    </p>
    <mat-radio-group
      [(ngModel)]="healthDeclaration"
      aria-label="Select an option"
    >
      <mat-radio-button value="false">Nee</mat-radio-button>
      <mat-radio-button value="true">Ja</mat-radio-button>
    </mat-radio-group>
    <p>Temperatuur {{ temperature }} °C</p>
    <mat-slider
      style="width: 100%"
      [(ngModel)]="temperature"
      min="30"
      max="40"
      tickInterval="1"
      [thumbLabel]="true"
      step="1"
    ></mat-slider>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="warn" (click)="close()">Terug</button>
  <button mat-raised-button color="primary" (click)="confirm()">
    Bevestig
  </button>
</div>
